import React, { useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { FormField } from "../../../../sharedComponents/formField";

import { getAvailableFilters } from "../../../../store/actions/index";
import { PanelBody, PanelFooter } from "../../../../sharedComponents/filterPanel";

const AdvancedFilterPanel = ({ getAvailableFilters, availableFilters, handleSubmit, resetForm, onReset }) => {
	useEffect(() => {
		getAvailableFilters();
	}, [getAvailableFilters]);

	const resetFilter = () => {
		resetForm("RecipesAdvancedFilter");
		onReset();
	};

	return (
		<form className="advanced-filter-form" onSubmit={handleSubmit}>
			<PanelBody>
				<div className="row">
					{availableFilters &&
						availableFilters.length > 0 &&
						availableFilters.map(({ group, name, label }, index) => {
							return (
								<Field
									key={index}
									label={label}
									name={name}
									type="select"
									formGroupClass="col-6"
									options={group}
									component={FormField}
								/>
							);
						})}
				</div>
			</PanelBody>
			<PanelFooter className="pt-0">
				<div className="text-right pt-3 pb-3">
					<button className="btn btn-default" type="button" onClick={resetFilter}>
						Reset
					</button>
					<button className="btn btn-primary-dark text-uppercase" type="submit">
						Filter now
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapStateToProps = (state) => ({
	availableFilters: state.Recipes.availableFilters
});

const mapDispatchToProps = {
	getAvailableFilters,
	resetForm: reset
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "RecipesAdvancedFilter"
	})(AdvancedFilterPanel)
);
